import React, { ReactNode } from 'react';

import Spinner from 'react-bootstrap/Spinner';

interface LoaderProps{
    children: ReactNode;
    loading: boolean;
    error?: {message: string};
}

const Loader: React.FC<LoaderProps> = ({children, loading, error}) => {


    return(
    <>
        {loading ? (
            <div className='d-flex justify-content-center align-items-center g-4'>
                <Spinner as="span" animation="border" role="status"/> 
                <p>Chargement...</p>
            </div>
        ) : error ? (
            <p>Erreur lors de la requête</p>
        ) : (
            children
        )}
    </>
    );

};


export default Loader;